import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getProfile } from "./actions/settings";

// import { connect } from 'react-redux';
// import * as select from 'reducers';
// import * as actionsSession from 'actions/session';
import {
  Footer,
  Header,
  NotFound,
  PasswordResetModal,
  Programs,
  ProgramModal,
  LoginModal,
  HelpModal,
  TermsModal,
  Settings,
  History,
  Payment,
  Loading,
  Contact,
  Reports,
} from "./components";
import axios from "./api/axios";

import "./styles/zon/app.scss";

import "./styles/base/_typography.scss";
import "./styles/base/_layout.scss";
import "./styles/components/_spinners.scss";
import "./styles/App.scss";
import SecurityQuestions from "./components/SecurityQuestions";
import PasswordReset from "./components/PasswordReset";
import FileMakerDown from "./components/FileMakerDown";
import SuccessPage from "./components/Payment/SuccessPage";
import NavigateToBackOffice from "./components/NavigateToBackOffice";

const authedPaths = ["reports", "settings", "history", "programs"];

function Root() {
  const dispatch = useDispatch();
  const { userId, userdata } = useSelector((state) => state.session);
  const { settingsLoading } = useSelector((state) => state.settings);
  const [isFMActive, setIsFMActive] = useState(true);
  const [authCheckDone, setAuthCheckDone] = useState(false);
  const { key: locationKey } = useLocation();

  useEffect(() => {
    if (isFMActive) {
      getProfile(dispatch);
    }
  }, [dispatch, isFMActive, locationKey]);

  useEffect(() => {
    if (settingsLoading === 0) {
      setAuthCheckDone(true);
    }
  }, [settingsLoading]);

  const checkIsFileMakerOnline = useCallback(async () => {
    try {
      if (process.env.NODE_ENV === "development") {
        setIsFMActive(true);
        return;
      }
      await axios.get("/api/fm-status");

      setIsFMActive(true);
    } catch (error) {
      setIsFMActive(false);
      // Test again in 2 minutes
      setTimeout(() => checkIsFileMakerOnline(), 2 * 60 * 1000);
    }
  }, []);

  useEffect(() => {
    checkIsFileMakerOnline();
  }, [checkIsFileMakerOnline]);

  const isAuthed = useMemo(() => !!userId && userdata?.verified, [userdata, userId]);

  const shouldDisplaySecurityQuestions = useMemo(
    () => isAuthed && !userdata.has_recovery && !userdata.is_sso_user && !userdata.is_impersonating,
    [isAuthed, userdata]
  );

  if (isFMActive === false) {
    return (
      <div className="app__wrapper">
        <FileMakerDown />
      </div>
    );
  }

  if (!authCheckDone) {
    return <Loading />;
  }

  if (shouldDisplaySecurityQuestions) {
    return (
      <div className="app__wrapper">
        <Header />
        <div className="donation_portal__container">
          <Routes>
            <Route path="/" element={<Payment />} />
            <Route path="*" element={<SecurityQuestions />} />
          </Routes>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app__wrapper">
      <Header />

      {/* <AnalyticsTracker /> */}
      <div className="donation_portal__container">
        <Routes>
          {isAuthed && <Route path="/reports" element={<Reports />} />}
          {isAuthed && <Route path="/reports/:program_id" element={<Reports />} />}
          {isAuthed && <Route path="/reports/:program_id/:report" element={<Reports />} />}
          {isAuthed && <Route path="/settings" exact element={<Settings />} />}
          {isAuthed && <Route path="/history" exact element={<History />} />}
          {isAuthed && <Route path="/programs" exact element={<Programs />} />}
          {isAuthed && <Route path="/account/security-questions" element={<SecurityQuestions />} />}

          {!isAuthed && <Route path="/password-reset/:token" element={<PasswordReset />} />}
          {authedPaths.map((path) => (
            <Route key={path} path={path} element={<Navigate replace to="/" />} />
          ))}
          <Route path="/contact" element={<Contact />} />

          <Route path="/support-bostjan-cifer-afes-5231" element={<Navigate replace to="/support-ifes-bostjan-cifer-slovenia-5558" />} />
          <Route path="/thank-you" element={<SuccessPage />} />
          <Route path="/:charity" element={<Payment />} />
          <Route path="/" element={<Payment />} />

          <Route path="*" element={<NotFound />} />
          <Route exact path="/backoffice" element={<NavigateToBackOffice />} />
        </Routes>
        <LoginModal isAuthed={isAuthed} />
        <PasswordResetModal />
        <ProgramModal />
        <HelpModal />
        <TermsModal />
      </div>
      <Footer />
    </div>
  );
}

export default Root;
